{
    "financialProducts": [
        {
            "id": "MC",
            "description": "Crédito Clásico",
            "creditTimeUnit": "MONTH",
            "currencyCode": "EUR",
            "durationsRange": {
                "minimum": 12,
                "maximum": 96,
                "step": 12,
                "defaultValue": 72,
                "description": "DURACIÓN"
            },
            "downPaymentGrossAmountRange": {
                "minimum": 0.0,
                "maximum": 50000.0,
                "step": 1.0,
                "defaultValue": 3000.0,
                "description": "ENTRADA"
            },
            "loanGrossAmountRange": {},
            "cpiProducts": [
                {
                    "id": "7044A",
                    "financialProductId": "MC",
                    "name": " ESTANDAR PARTICULARES CLASICO Seg Protec Pago",
                    "description": "ESTANDAR PARTICULARES CLÁSICO- Seg Protec Pago"
                }
            ],
            "name": "Crédito Clásico"
        },
        {
            "id": "MCM",
            "description": "Crédito Multiopción",
            "mileageUnit": "KILOMETERS",
            "creditTimeUnit": "MONTH",
            "currencyCode": "EUR",
            "durationsRange": {
                "minimum": 24,
                "maximum": 60,
                "step": 12,
                "defaultValue": 60,
                "description": "DURACIÓN"
            },
            "annualMileagesRange": {
                "minimum": 10000,
                "maximum": 30000,
                "step": 5000,
                "defaultValue": 15000,
                "description": "KILÓMETROS ANUALES"
            },
            "downPaymentGrossAmountRange": {
                "minimum": 5000.0,
                "maximum": 45000.0,
                "step": 1000.0,
                "defaultValue": 30000.0,
                "description": "ENTRADA"
            },
            "loanGrossAmountRange": {},
            "cpiProducts": [
                {
                    "id": "7045A",
                    "financialProductId": "MCM",
                    "name": " ESTANDAR PARTICULARES MULTIOPCION Seg Protec Pag",
                    "description": "ESTANDAR PARTICULARES MULTIOPCION- Seg Protec Pago"
                }
            ],
            "name": "Crédito Multiopción"
        }
    ]
}
